export default {
    pageName: 'Onsite Today',
    people: 'People',
    search: {
        title: '',
        placeholder: 'Search by Employee ID'
    },
    header: {
        detail: 'Detail',
        status: 'Status'
    }
}
